import './accountBenefitsAccountInformationBox.scss';

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ components
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { formatDate } = require('utilities/dateHelper');
const { DATE_FORMAT_CAMELCASED } = require('constants/index');

class AccountBenefitsAccountInformationBox extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildFetching() {
        return (
            <OKSectionBox>
                <LoadingSection />
            </OKSectionBox>
        );
    }

    buildFailure(error) {
        return (
            <OKSectionBox>{error}</OKSectionBox>
        );
    }

    buildSuccess() {

        const { accountNumber, latestSettlementDate } = this.props;
        const blockClass = 'account-benefits-account-information';

        return (
            <div className={blockClass}>
                <div className={`${blockClass}__title`}>
                    <FormattedText value="accountBenefits-accountInformation" />
                </div>
                <div className={`${blockClass}__information-box`}>
                    <div className={`${blockClass}__label`}>
                        <FormattedText value="accountBenefits-accountNumber" />
                    </div>
                    <div className={`${blockClass}__value`}>
                        {accountNumber}
                    </div>
                </div>
                <div className={`${blockClass}__information-box`}>
                    <div className={`${blockClass}__label`}>
                        <FormattedText value="accountBenefits-latestSettlement" />
                    </div>
                    <div className={`${blockClass}__value`}>
                        {formatDate(latestSettlementDate, DATE_FORMAT_CAMELCASED)}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immAccountBenefitsData } = this.props;

        let benefitsBox;
        if (immAccountBenefitsData.get('isFetching')) {
            benefitsBox = this.buildFetching();
        } else if (immAccountBenefitsData.get('hasBeenFetched') && immAccountBenefitsData.get('error') === '') {
            benefitsBox = this.buildSuccess();
        } else if (immAccountBenefitsData.get('hasBeenFetched') && immAccountBenefitsData.get('error') !== '') {
            benefitsBox = this.buildFailure(immAccountBenefitsData.get('error'));
        }

        benefitsBox = this.buildSuccess();
        return benefitsBox;
    }
}

AccountBenefitsAccountInformationBox.propTypes = {
    accountNumber: PropTypes.string,
    immAccountBenefitsData: PropTypes.object,
    latestSettlementDate: PropTypes.string,
};

module.exports = AccountBenefitsAccountInformationBox;
